import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Spinner,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Student_Result = () => {
  const [examResults, setExamResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = sessionStorage.getItem("user_id");
 const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  useEffect(() => {
    const fetchExamResults = async () => {
      if (!userId) {
        setError("User ID is not available in session storage.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          `${BASE_URL}/admin/exam/list_result_to_student.php`,
          { pass: userId ,
            school_id:sessionStorage.getItem("school_id")
          }
        );
        if (response.data.success) {
          const filteredDetails = response.data.exam_result.filter(
            (detail) => detail.academic_year_id === academicId
          );
          // const results = response.data.exam_result || [];
          setExamResults(filteredDetails);
        } else {
          setError(
            "Unexpected response structure: " + JSON.stringify(response.data)
          );
        }
      } catch (error) {
        setError("Error fetching exam results: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExamResults();
  }, [userId,academicId]);

  if (loading) {
    return (
      <Box textAlign="center" p={4}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box color="red.500" textAlign="center" p={4}>
        {error}
      </Box>
    );
  }

  // Group the exam results by category
  const groupedResults = examResults.reduce((acc, result) => {
    const category = result.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(result);
    return acc;
  }, {});

  return (
    <Box borderRadius="md" mx="auto" p={4}>
      {" "}
      {/* Added padding to the outer box */}
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Results</h1>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Student</span>
            </Link>{" "}
            / <span>Exam</span> / <span>Exam Results</span>
          </div>
        </div>
        <Box bg="white" borderRadius="xl" boxShadow="lg" p={8}>
          <VStack spacing={8} align="stretch">
            <Accordion allowToggle>
              {Object.keys(groupedResults).map((category, catIndex) => (
                <AccordionItem
                  key={catIndex}
                  border="none"
                  mb={4}
                  bg="white"
                  borderRadius="xl"
                  boxShadow="sm"
                  _last={{ mb: 0 }}
                  overflow="hidden"
                >
                  <AccordionButton
                    bgGradient="linear(to-r, teal.300, cyan.200)"
                    _expanded={{
                      bgGradient: "linear(to-r, teal.400, cyan.300)",
                      color: "white",
                      boxShadow: "md",
                    }}
                    _hover={{
                      bgGradient: "linear(to-r, teal.400, cyan.300)",
                      transform: "translateY(-1px)",
                    }}
                    py={6}
                    color="white"
                    transition="all 0.3s"
                  >
                    <Box
                      flex="1"
                      textAlign="left"
                      display="flex"
                      alignItems="center"
                    >
                      <Text
                        fontSize="lg"
                        fontWeight="bold"
                        letterSpacing="wide"
                      >
                        {category}
                      </Text>
                      <Box
                        ml={4}
                        px={3}
                        py={1}
                        bg="whiteAlpha.300"
                        borderRadius="full"
                        fontSize="sm"
                      >
                        {groupedResults[category].length} subjects
                      </Box>
                    </Box>
                    <AccordionIcon
                      fontSize="24px"
                      transition="transform 0.3s"
                      _expanded={{ transform: "rotate(-180deg)" }}
                    />
                  </AccordionButton>

                  <AccordionPanel
                    pb={6}
                    pt={4}
                    bgGradient="linear(to-b, teal.50, cyan.50)"
                  >
                    <Box
                      overflowX="auto"
                      borderRadius="lg"
                      bg="white"
                      boxShadow="xl"
                    >
                      <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="md">
                        <Thead>
                          <Tr bgGradient="linear(to-r, teal.50, cyan.50)">
                            <Th
                              py={5}
                              px={6}
                              fontSize="sm"
                              color="teal.700"
                              borderBottom="2px"
                              borderColor="teal.100"
                            >
                              Subject Name
                            </Th>
                            <Th
                              py={5}
                              px={6}
                              fontSize="sm"
                              color="teal.700"
                              textAlign="center"
                              borderBottom="2px"
                              borderColor="teal.100"
                            >
                              Written Exam
                            </Th>
                            <Th
                              py={5}
                              px={6}
                              fontSize="sm"
                              color="teal.700"
                              textAlign="center"
                              borderBottom="2px"
                              borderColor="teal.100"
                            >
                              Internal Exam
                            </Th>
                            <Th
                              py={5}
                              px={6}
                              fontSize="sm"
                              color="teal.700"
                              textAlign="center"
                              borderBottom="2px"
                              borderColor="teal.100"
                            >
                              Total Score
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {groupedResults[category].map((result, index) => (
                            <Tr
                              key={index}
                              _hover={{
                                bg: "teal.50",
                                transform: "scale(1.01)",
                                transition: "all 0.2s",
                              }}
                              transition="all 0.2s"
                            >
                              <Td py={4} px={6}>
                                <Text fontWeight="medium" color="teal.700">
                                  {result.subject}
                                </Text>
                              </Td>
                              <Td py={4} px={6} textAlign="center">
                                <Box
                                  display="inline-flex"
                                  bgGradient="linear(to-r, cyan.300, teal.200)"
                                  color="teal.800"
                                  px={4}
                                  py={2}
                                  borderRadius="full"
                                  fontSize="sm"
                                  fontWeight="medium"
                                  boxShadow="sm"
                                  _hover={{ transform: "translateY(-1px)" }}
                                  transition="transform 0.2s"
                                >
                                  {result.written_mark || "N/A"}
                                </Box>
                              </Td>
                              <Td py={4} px={6} textAlign="center">
                                <Box
                                  display="inline-flex"
                                  bgGradient="linear(to-r, teal.200, green.200)"
                                  color="teal.800"
                                  px={4}
                                  py={2}
                                  borderRadius="full"
                                  fontSize="sm"
                                  fontWeight="medium"
                                  boxShadow="sm"
                                  _hover={{ transform: "translateY(-1px)" }}
                                  transition="transform 0.2s"
                                >
                                  {result.internal_mark || "N/A"}
                                </Box>
                              </Td>
                              <Td py={4} px={6} textAlign="center">
                                <Box
                                  display="inline-flex"
                                  bgGradient="linear(to-r, teal.300, cyan.300)"
                                  color="teal.800"
                                  px={4}
                                  py={2}
                                  borderRadius="full"
                                  fontSize="sm"
                                  fontWeight="bold"
                                  boxShadow="sm"
                                  _hover={{ transform: "translateY(-1px)" }}
                                  transition="transform 0.2s"
                                >
                                  {result.marks || "N/A"}
                                </Box>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </VStack>
        </Box>
      </div>
    </Box>
  );
};

export default Student_Result;
